__turbopack_context__.v({
  "form": "contact-form-module-scss-module__yCSpKG__form",
  "submitButton": "contact-form-module-scss-module__yCSpKG__submitButton",
});
